import GetAppIcon from '@mui/icons-material/GetApp';
import type { Theme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  industryTrackerItemContainer: {
    border: 'solid 1px #f2f5f7',
    padding: '25px',
    cursor: 'pointer',
  },
  industryTrackerItemInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  industryTrackerItemChip: {
    ...theme.palette.accent,
  },
  industryTrackerItemChipContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  listIcon: {
    color: '#5f91cc',
  },
  disabled: {
    opacity: 0.3,
    cursor: 'not-allowed',
  },
  tooltipWrapper: {
    display: 'block',
    width: '100%',
  },
}));

type TrackerProps = {
  title: string;
  onClick: () => void;
  enabled: boolean;
  disabledTooltip?: string;
  Icon?: typeof GetAppIcon;
};

export const Tracker = ({
  title,
  onClick,
  enabled,
  disabledTooltip,
  Icon = GetAppIcon,
}: TrackerProps) => {
  const classes = useStyles();

  return (
    <Tooltip
      title={
        !enabled ? disabledTooltip || 'Your current plan does not include access to this file.' : ''
      }
      disableHoverListener={!!enabled}
      arrow
    >
      <span className={classes.tooltipWrapper}>
        <Grid
          className={`${classes.industryTrackerItemContainer} ${enabled ? '' : classes.disabled}`}
          container
          onClick={enabled ? onClick : undefined}
        >
          <Grid className={classes.industryTrackerItemChipContainer} size={3}>
            <Icon className={classes.listIcon} />
          </Grid>
          <Grid className={classes.industryTrackerItemInfo} size={9}>
            <Typography variant='subtitle1'>{title}</Typography>
          </Grid>
        </Grid>
      </span>
    </Tooltip>
  );
};
